import React from 'react';
import '../../css/process.css'

function refresh() {

    return (
      <div className="loader-overlay flex items-center justify-center fixed top-0 left-0 w-full h-full bg-opacity-50 z-50">
          <span className="cloudupload"></span>
        </div>
    );
}

export default refresh;
